import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Settings2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCustomerSystems } from "@/hooks/useCustomerSystems";
import { SYSTEM_COLORS } from "./customerConstants";
import { CustomerSystemsManager } from "./CustomerSystemsManager";

export const systemTestId = (name) => `system-${name.toLowerCase().replace(/\s+/g, "-")}`;

export function SystemBadges({ names = [] }) {
  const systems = useCustomerSystems();
  return (
    <span className="flex flex-wrap gap-1.5 pt-0.5" data-testid="customer-system-badges">
      {names.map((n) => {
        const s = systems.find((x) => x.name === n);
        return (
          <span key={n} title={n} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${SYSTEM_COLORS[s?.color] || SYSTEM_COLORS.slate}`} data-testid={`customer-system-badge-${systemTestId(n)}`}>
            {s?.short_label || n}
          </span>
        );
      })}
    </span>
  );
}

export function SystemChipsField({ value = [], onToggle, onReplace }) {
  const systems = useCustomerSystems();
  const { user } = useAuth();
  const [manageOpen, setManageOpen] = useState(false);
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <Label>Systeme</Label>
        {user?.role === "admin" && (
          <button type="button" onClick={() => setManageOpen(true)} className="text-xs text-primary hover:underline inline-flex items-center gap-1" data-testid="systems-manage-btn">
            <Settings2 className="w-3.5 h-3.5" />Systeme verwalten
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {systems.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onToggle(s.name)}
            title={s.name}
            className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium select-none transition-colors ${
              value.includes(s.name) ? `${SYSTEM_COLORS[s.color] || SYSTEM_COLORS.slate} ring-2 ring-offset-2 ring-current` : "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400 hover:bg-gray-200"
            }`}
            data-testid={systemTestId(s.name)}
          >
            {s.short_label || s.name}
          </button>
        ))}
        {systems.length === 0 && <p className="text-sm text-muted-foreground">Noch keine Systeme angelegt.</p>}
      </div>
      {manageOpen && (
        <CustomerSystemsManager
          open={manageOpen}
          onOpenChange={setManageOpen}
          onRenamed={(oldName, newName) => onReplace?.(value.map((v) => (v === oldName ? newName : v)))}
          onDeleted={(name) => onReplace?.(value.filter((v) => v !== name))}
        />
      )}
    </div>
  );
}
